<template>
  <toggle-button
    :sync="sync"
    :id="id"
    :value="model"
    :color="color"
    :disabled="disabled"
    @change="onChangeEventHandler"
  />
</template>

<script>
//https://github.com/euvl/vue-js-toggle-button
import { ToggleButton } from 'vue-js-toggle-button';

export default {
  name: 'CustomToggle',
  components: {
    ToggleButton
  },
  props: {
    id: {
      type: String,
      default: `custom-toggle-${Math.random()}`,
    },
    value: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: '#2DB782',
    },
    sync: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: this.value,
    };
  },
  watch: {
    model(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.model = val;
    },
  },
  methods: {
    onChangeEventHandler(newValue){
      this.model = newValue.value;
    }
  }
};
</script>
